"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _useAnnouncedMessage = _interopRequireDefault(require("../utils/_useAnnouncedMessage"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ScreenReaderMessage = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-screen-reader-message';
/**
 * The **ScreenReaderMessage** component provides a way to
 * programmatically expose dynamic content changes in a way
 * that can be announced by screen readers.
 *
 * It is important to note that, at this time,
 * screen readers do not inform users of alerts that are present on the page
 * before page load completes. Use the **ScreenReaderMessage** component when
 * a message is not tied to a page refresh or clicking a button that completes
 * a workflow (like submitting a form).
 *
 * See the [Patterns/Message Handling](./?path=/docs/patterns-message-handling--docs) page
 * for more detailed information on selecting the appropriate messaging component.
 */
// eslint-disable-next-line max-len
var ScreenReaderMessage = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? (0, _assign.default)((0, _assign.default)({}, _props), addChildProps(ScreenReaderMessage, _props)) : _props;
  var className = props.className,
    children = props.children,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 1000 : _props$delay,
    _props$isAlert = props.isAlert,
    isAlert = _props$isAlert === void 0 ? false : _props$isAlert,
    onMessageAnnounced = props.onMessageAnnounced,
    announce = props.announce,
    otherProps = __rest(props, ["className", "children", "delay", "isAlert", "onMessageAnnounced", "announce"]);
  var announcedMessage = (0, _useAnnouncedMessage.default)({
    announce: announce,
    message: children,
    onMessageAnnounced: onMessageAnnounced,
    resetDelay: delay
  });
  var classnames = _bind.default.bind(_ScreenReaderMessage.default);
  var classes = classnames(CSS_BLOCK, className);
  return /*#__PURE__*/_react.default.createElement("span", (0, _assign.default)({}, otherProps, {
    className: classes,
    ref: ref,
    role: isAlert ? 'alert' : 'status'
  }), announcedMessage);
});
ScreenReaderMessage.displayName = 'ScreenReaderMessage';
ScreenReaderMessage.propTypes = {
  /** Text to read to the consumer. */
  children: _propTypes.default.string,
  /** Controls the length of the `setTimeout` delay for clearing the message from the DOM.
  * Default delay is 1000ms if this prop is not set.
  * Use milliseconds ie. `1500`
  */
  delay: _propTypes.default.number,
  /** Set `isAlert` to **true** to interrupt the user,
   * by adding `role="alert"`, which implicitly has `aria-live="assertive"`.
   *
   * This should be avoided unless absolutely necessary.
   * Consider using a **MessageDialog** or
   * **MessageView** instead.
   *
   * When `isAlert` is unset or falsy the component has `role="status"`
   * which implicitly has`aria-live="polite"` and is less aggressive.
   * */
  isAlert: _propTypes.default.bool,
  /** Custom classes to be added to the `<span>` tag.  */
  className: _propTypes.default.string,
  /** Controls whether the message (children) is rendered. This assists screen readers
   * announce a message that was not part of the DOM on page load. Use in conjunction
   * with the `onMessageAnnounced` prop.
   */
  announce: _propTypes.default.bool,
  /** Callback function when the message (children)
   * removes itself from the DOM after several seconds.
   * This assists screen readers announce a message more than
   * once when the message is identical to the last. Use in
   * conjunction with the `announce` prop.
   * */
  onMessageAnnounced: _propTypes.default.func
};
var _default = exports.default = ScreenReaderMessage;